import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuiItemComponent } from '@ral/ui:aui/item';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryTitleComponent } from '@storyteller/title';
@Component({
    selector: 'app-successfully-subscribed-page',
    template: `
        <section>
            <story-container class="flex min-h-[calc(75vh-200px)] flex-col justify-center text-center">
                <aui-icon icon="check-circle" class="text-[48px] text-info" />
                <story-title [headingLevel]="1" className="story-font-headline1 pb-2">Potvrzeno</story-title>
                <story-description>Uspěšně jste se přihlásili k odběru newsletteru.</story-description>
                <div class="m-auto mt-6 inline-block">
                    <a [routerLink]="['/']" auiItem [size]="'40'" [color]="'primary'">
                        <span auiItemLabel>Zpět na hlavní stránku</span>
                    </a>
                </div>
            </story-container>
        </section>
    `,
    imports: [
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryContainerComponent,
        AuiIconComponent,
        AuiItemComponent,
        RouterLink,
    ],
})
export class SuccessfullySubscribedPageComponent {}
